var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSortAscending = function SvgSortAscending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M0 3.158a1.5 1.5 0 0 1 1.5-1.5h8.888a1.5 1.5 0 1 1 0 3H1.5a1.5 1.5 0 0 1-1.5-1.5M0 12a1.5 1.5 0 0 1 1.5-1.5h11.143a1.5 1.5 0 0 1 0 3H1.5A1.5 1.5 0 0 1 0 12M0 20.842a1.5 1.5 0 0 1 1.5-1.5h21a1.5 1.5 0 0 1 0 3h-21a1.5 1.5 0 0 1-1.5-1.5M13.268 8.013a1.3 1.3 0 0 1-.005-1.84l4.257-4.256a1.3 1.3 0 0 1 1.84.005l4.131 4.132a1.3 1.3 0 0 1 .005 1.84 1.3 1.3 0 0 1-1.84-.005l-1.905-1.905v9.099c.002.718-.579 1.299-1.297 1.297a1.31 1.31 0 0 1-1.304-1.304v-9.1l-2.042 2.042a1.3 1.3 0 0 1-1.84-.005",
    clipRule: "evenodd"
  })));
};
export default SvgSortAscending;